import { jsx as o } from "react/jsx-runtime";
const e = ({
  width: t,
  height: l,
  className: r
}) => /* @__PURE__ */ o(
  "svg",
  {
    className: r,
    height: l,
    viewBox: "0 0 20 19",
    width: t,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M9.64,10.556l-.822-1.1-6.052-8.1H5.2L10.172,8l.822,1.1,6.311,8.454H14.867ZM17.635,0,11.108,7,5.881,0H.068L7.879,10.46,0,18.91H1.849L8.7,11.561l5.489,7.35H20L11.928,8.1,19.482,0Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  e as Content
};
